
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leadPages/[pageId]",
      function () {
        return require("private-next-pages/leadPages/[pageId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leadPages/[pageId]"])
      });
    }
  